import {constants} from '@/utils/Constants.js'

import store from '../store/store'

export const getReviewReasons = (reasonType, isVideo = false) => {
  const allReviewReasons = store.getters['campaign/targetingLookups'].review_reasons

  if (!allReviewReasons) {
    return []
  }

  return allReviewReasons
    .filter(reason => reason.reason_type === reasonType)
    .filter(reason => {
      if (isVideo) {
        return constants.VIDEOS_REVIEW_REASONS_IDS.includes(reason.id)
      } else {
        return constants.IMAGES_REVIEW_REASONS_IDS.includes(reason.id)
      }
    })
}
